<forge-card telemetry="Card-SmartMeterPortalUsageChart-UtilityBilling" no-padding>
  <forge-toolbar fxLayout="column">
    <h2 slot="start" class="forge-typography--heading4">Smart Meter Portal Usage</h2>
  </forge-toolbar>

  <div class="metadata-padding">
    @if (isLoaded) {
      <div>
        @if (showChart) {
          <chartjs-container [config]="chartConfig">
          </chartjs-container>
        }
        @if (!chartHasData) {
          <div>
            Not enough data to display graph
          </div>
        }
      </div>
    }

    @if (!isLoaded) {
      <busy-indicator [chart]="true"></busy-indicator>
    }
  </div>
</forge-card>
